<template>
    <div class="container">
        <div class="header-Card">
            <img class="header-logo" src="../assets/img/header-logo.svg" alt="" />
            <el-dropdown>
                <span class="el-dropdown-link">
                    <i class="el-icon-user" style="color: #fff; font-size: 20px"></i>
                    <span style="color: #fff">{{ userInfo && userInfo.phoneNum }}</span
                    ><i style="color: #fff" class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="getExit">退出</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
        <div class="banner">
            <div class="welcome">
                团体预约
                <div>学校 / 其他机构请由此进行团体购票</div>
            </div>
        </div>
        <div class="header">
            <div class="nav flex-row">
                <router-link :to="'/' + item.path" v-for="(item, index) in navList" :key="index">
                    <div
                        class="nav-item"
                        :class="currentTab == index ? 'activeNav' : ''"
                        @click="changeTab(index)"
                    >
                        {{ item.name }}
                    </div>
                </router-link>
            </div>
        </div>
        <!-- 	<div class="breadcrumb">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
				<el-breadcrumb-item :to="{ path: '/' }">散客预约</el-breadcrumb-item>
			</el-breadcrumb>
		</div> -->
        <div class="section">
            <img class="img-bg" src="../assets/img/bg.svg" alt="" />
            <keep-alive>
                <!-- 需要缓存的组件 -->
                <router-view v-if="$route.meta.keepAlive"></router-view>
            </keep-alive>
            <router-view v-if="!$route.meta.keepAlive"></router-view>
        </div>
        <div class="footer">©四川大学博物馆</div>
    </div>
</template>

<script>
import tool from "../utils/tools.js";
// 引入公共的bus，来做为中间传达的工具
import { eventBus } from "../utils/eventBus.js";
import { login, officialWebsiteLogout, merchantNo } from "@/utils/http.js";
name: "Home";
export default {
    data() {
        return {
            navList: [
                {
                    name: "门票预约",
                    path: "Home",
                },
                {
                    name: "团队认证",
                    path: "TeamInfo",
                },
                {
                    name: "个人中心",
                    path: "MyCenter",
                },
            ],
            currentTab: 0,
            skey: "",
            userInfo: {},
        };
    },
    mounted() {
        //页面刷新时获取当前路由中配置的currentTab
        this.currentTab = this.$route.meta.currentTab;
        // 监听事件总线
        eventBus.$on("setcurrentTab", res => {
            // 接收认证提示弹框发送来的消息
            this.currentTab = res;
        });
        this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
        // let skey = this.$route.query.skey;
        // if (skey) {
        // 	this.skey = skey;
        // }
        // let token = tool.getStore("token")
        // if (token == null) {
        // 	this._login();
        // }
    },
    methods: {
        getExit() {
            officialWebsiteLogout({
                merchantNo: merchantNo,
            }).then(res => {
                if (res.code == 0) {
                    this.$message({
                        message: "退出登录",
                        type: "success",
                    });
                    tool.setStore("token", null);
                    this.$router.push({
                        path: "/",
                    });
                } else {
                    this.$message({
                        message: "退出失败",
                        type: "error",
                    });
                }
            });
            console.log(123456789);
        },
        // 以及菜单切换
        changeTab(val) {
            this.currentTab = val;
        },
        async _login() {
            let param = {
                merchantNo: merchantNo,
                appId: "f780ea5b76544c1fa20da8048f1dd424",
                skey: this.skey,
            };
            const res = await login(param);
            if (res.code == 0) {
                tool.setStore("token", res.token);
            }
        },
    },
};
</script>

<style scoped>
.container {
    position: relative;
    width: 100%;
    box-sizing: border-box;
    background: #f8f6f0;
}

.container .banner {
    width: 100%;
    height: 242px;
    background-image: url(../assets/img/banner.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
}

.banner .welcome {
    font-size: 42px;
    font-family: Source Han Serif SC-Bold, Source Han Serif SC;
    font-weight: bold;
    color: #ffffff;
    padding-left: 360px;
    padding-top: 83px;
    box-sizing: border-box;
}

.welcome div {
    margin-top: 16px;
    font-size: 26px;
    font-family: Source Han Serif CN-Medium, Source Han Serif CN;
    font-weight: 500;
}

.header {
    width: 100%;
    height: 44px;
    padding: 0 360px;
    box-sizing: border-box;
    background: rgba(0, 0, 0, 0.21);
    margin-top: -44px;
}

.header .nav-item {
    width: 148px;
    height: 44px;
    line-height: 44px;
    text-align: center;
    font-size: 16px;
    font-family: Source Han Serif CN-Medium, Source Han Serif CN;
    font-weight: 500;
    color: rgba(255, 253, 249, 0.6);
    background: #230805;
}

/* 一级菜单激活样式 */
.activeNav {
    background: #ba2a17 !important;
    color: #fff !important;
    border-bottom: 1.5px solid #fff;
}

.breadcrumb {
    width: 100%;
    padding: 0 360px;
    box-sizing: border-box;
}

.section {
    margin-top: 10px;
    position: relative;
}
.img-bg {
    width: 100%;
    position: absolute;
    bottom: 0;
    z-index: 0;
}
.footer {
    width: 100%;
    height: 97px;
    background: #ba2a17;
    text-align: center;
    line-height: 97px;
    font-size: 16px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    margin-top: 24px;
}
.header-Card {
    height: 80px;
    background: #ba2a17;
    border-radius: 0px 0px 0px 0px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 360px;
}
.header-logo {
    width: 223px;
    height: 34px;
}
</style>
